import { Outlet } from 'react-router-dom';
import { ProductScopeProvider } from '../context/ProductScopeContext';
import type { AdminProductScope } from '../lib/product-scope';
import { PRODUCT_SCOPE_LABELS } from '../lib/product-scope';

export function ProductScopeLayout({ scope }: { scope: AdminProductScope }) {
  return (
    <ProductScopeProvider scope={scope}>
      <div className="mb-4 flex items-center gap-2">
        <span className="rounded-full bg-ops-accent-soft px-3 py-1 text-xs font-semibold uppercase tracking-wide text-ops-text">
          {PRODUCT_SCOPE_LABELS[scope]}
        </span>
        <span className="text-xs text-ops-muted">Административный контур продукта</span>
      </div>
      <Outlet />
    </ProductScopeProvider>
  );
}
